module.exports = __webpack_public_path__ + "static/media/item3.7b076323.jpg";